(function () {
  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }

  function initParallax(section) {
    if (!section || section.dataset.osParallaxInit === '1') return;
    section.dataset.osParallaxInit = '1';

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var image = section.querySelector('.our-story__image');
    var scribble = section.querySelector('.our-story__scribble');
    if (!image && !scribble) return;

    var imgStrength = parseFloat(section.dataset.osImgStrength) || 0;
    var scribbleStrength = parseFloat(section.dataset.osScribbleStrength) || 0;
    var imgEnd = parseFloat(section.dataset.osImgEnd) || 0.5;
    var scribbleEnd = parseFloat(section.dataset.osScribbleEnd) || 0.7;
    var imgTrigger = parseFloat(section.dataset.osTrigger);
    if (isNaN(imgTrigger)) imgTrigger = 0.1;
    var scribbleTrigger = parseFloat(section.dataset.osScribbleTrigger);
    if (isNaN(scribbleTrigger)) scribbleTrigger = imgTrigger;

    var visible = false;
    var ticking = false;
    var mq = window.matchMedia('(min-width: 768px)');

    function reset() {
      if (image) image.style.setProperty('--os-img-py', '0px');
      if (scribble) scribble.style.setProperty('--os-scribble-py', '0px');
    }

    function update() {
      ticking = false;
      if (!mq.matches) { reset(); return; }
      var rect = section.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;

      // progress: 0 until section is `trigger` fraction into viewport, then ramps to 1
      var visiblePx = vh - rect.top;

      if (image) {
        var rawImg = (visiblePx - vh * imgTrigger) / vh;
        if (rawImg < 0) rawImg = 0;
        var p = clamp(rawImg / imgEnd, 0, 1);
        image.style.setProperty('--os-img-py', (imgStrength * (1 - p)).toFixed(2) + 'px');
      }
      if (scribble) {
        var rawSc = (visiblePx - vh * scribbleTrigger) / vh;
        if (rawSc < 0) rawSc = 0;
        var sp = clamp(rawSc / scribbleEnd, 0, 1);
        scribble.style.setProperty('--os-scribble-py', (scribbleStrength * (1 - sp)).toFixed(2) + 'px');
      }
    }

    function onScroll() {
      if (!visible || ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }

    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        visible = entries[i].isIntersecting;
        if (visible) {
          requestAnimationFrame(update);
        }
      }
    }, { rootMargin: '0px 0px 0px 0px', threshold: 0 });

    io.observe(section);

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    if (mq.addEventListener) {
      mq.addEventListener('change', function () { requestAnimationFrame(update); });
    } else if (mq.addListener) {
      mq.addListener(function () { requestAnimationFrame(update); });
    }

    // initial paint
    update();
  }

  function initAll() {
    var nodes = document.querySelectorAll('.our-story[data-parallax="true"]');
    for (var i = 0; i < nodes.length; i++) initParallax(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.our-story[data-parallax="true"]');
    if (section) initParallax(section);
  });
})();
